import React, { useCallback } from "react"
import PropTypes from "prop-types"
import { Form, DatePicker } from "antd"

import { ProgressModal } from "@components/Page"
import { ListAllProjectsOutputShape } from "@api/services/backstage"

import ReportFiltersForm from "../ReportFiltersForm"
import useDistributionsReport from "./helpers/useDistributionsReport"

const LABEL_TITLE = "Distributions Report"
const LABEL_MONTH = "Month"
const LABEL_MONTH_REQUIRED = "Select month"


const DistributionsReportModal = ({ modal, projects = [] }) => {
  const onReady = () => modal.current.close()

  const [ percent, start, stop, reset ] = useDistributionsReport(onReady)

  const renderExtraInput = useCallback(() => {
    const itemProps = {
      name: "month",
      label: LABEL_MONTH,
      rules: [
        {
          message: LABEL_MONTH_REQUIRED,
          required: true,
        },
      ]
    }

    const datePickerProps = {
      picker: "month",
      format: "MM/YYYY",
      placeholder: LABEL_MONTH_REQUIRED,
    }

    return (
      <Form.Item {...itemProps}>
        <DatePicker {...datePickerProps} />
      </Form.Item>
    )
  }, [])

  const renderFilters = useCallback(() =>
    <ReportFiltersForm
      onSubmit={start}
      projects={projects}
      renderExtraInput={renderExtraInput}
    />
  , [ start, projects, renderExtraInput ])

  const modalProps = {
    title: LABEL_TITLE,
    stop,
    reset,
    modal,
    start,
    percent,
    renderFilters,
  }

  return (
    <ProgressModal {...modalProps} />
  )
}

DistributionsReportModal.propTypes = {
  modal: PropTypes.shape().isRequired,
  projects: PropTypes.arrayOf(ListAllProjectsOutputShape),
}

export default DistributionsReportModal
